import { Component, PropsWithChildren } from 'react';
import { SentryMinimal } from '@bridebook/toolbox/src/sentry';
import ErrorComponent from '@bridebook/web/components/error/error-component';

interface ComponentErrorLevelBoundaryProps extends PropsWithChildren {
  component?: string;
}

interface ComponentErrorLevelBoundaryState {
  hasError: boolean;
}

// The Crowdin In-Context widget (internal tool) can generate errors because it
// changes the DOM structure outside react
class ComponentErrorLevelBoundary extends Component<
  ComponentErrorLevelBoundaryProps,
  ComponentErrorLevelBoundaryState
> {
  constructor(props: ComponentErrorLevelBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    SentryMinimal()?.captureException(error, {
      tags: {
        source: 'ComponentErrorLevelBoundary',
        component: this.props.component,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorComponent
          statusCode={500}
          component={this.props.component ?? 'ComponentErrorLevelBoundary'}
        />
      );
    }

    return this.props.children;
  }
}

export default ComponentErrorLevelBoundary;
